import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import { Route, Switch, Redirect } from 'react-router';
import { useLocation, useParams } from 'react-router-dom';
import PasswordIlustration from '../../../assets/images/placeholder/partner.jpg';

import { GetUserById } from '../../../actions/auth/partnersInvitation';

import { PartnerInvitationStep0 } from './steps/step0';
import { PartnerInvitationStep1 } from './steps/step1';
import { PartnerInvitationStep2 } from './steps/step2';
import { PartnerInvitationStep3 } from './steps/step3';

export const PartnerInvitation = ({ }) => {
    const location = useLocation();
    const [user, setUser] = useState(undefined);

    const { userId } = useParams();

    const timestamp = new URLSearchParams(location.search).get("timestamp");
    const nonce = new URLSearchParams(location.search).get("nonce");
    const signature = new URLSearchParams(location.search).get("signature");

    useEffect(() => {
        GetUserById(userId, timestamp, nonce, signature)
            .then((userDto) => {
                setUser(userDto);
            });

    }, []);

    if(R.isNil(user)){
        return '';
    }

    return (
        <main role="main" className="view flex-grow-1 pb-sm pb-xl-gutter" style={{ minHeight: "500px" }}>
            <div className="container-fluid container-modal m-auto h-mh-inherit">
                <section className="card card-body card-lg rounded-top-left-xl rounded-bottom-right-xl h-inherit">
                    <h4 className="sr-only visually-hidden">Reset Compte</h4>
                    <div className="row justify-content-row gx-2 h-mh-inherit">
                        <div className="col-12 col-lg h-mh-inherit">
                            <img className="img-fluid img-contain container-md-wide mx-auto mt-4 my-lg-auto h-inherit" width="480" src={PasswordIlustration} alt="Assist@" />
                        </div>
                        <div className="col order-first order-lg-last h-mh-inherit">
                            <nav className="nav text-right mb-auto">
                                <h1 className="sr-only visually-hidden">Help</h1>
                                <span className="small font-weight-bold">Besoin d'aide ? <a className="text-info" href="mailto:contact@assistarobase.fr">Nous contacter</a></span>
                            </nav>
                            {
                                <Switch>
                                    <Route path="/auth/partner/invitation/:userId/activation/step0">
                                        <PartnerInvitationStep0 user={user} setUser={setUser} timestamp={timestamp} nonce={nonce} signature={signature} />
                                    </Route>
                                    <Route path="/auth/partner/invitation/:userId/activation/step1">
                                        <PartnerInvitationStep1 user={user} setUser={setUser} timestamp={timestamp} nonce={nonce} signature={signature} />
                                    </Route>
                                    <Route path="/auth/partner/invitation/:userId/activation/step2">
                                        <PartnerInvitationStep2 user={user} setUser={setUser} timestamp={timestamp} nonce={nonce} signature={signature} />
                                    </Route>
                                    <Route path="/auth/partner/invitation/:userId/activation/step3">
                                        <PartnerInvitationStep3 />
                                    </Route>

                                    <Route render={() => {
                                        if(!R.isNil(user) && !R.isNil(user.phoneNumber)){
                                            return <Redirect to={`/auth/partner/invitation/${userId}/activation/step0${location.search}`} />;
                                        }else{
                                            return <Redirect to={`/auth/partner/invitation/${userId}/activation/step2${location.search}`} />;
                                        }
                                        
                                    }} />
                                </Switch>


                                // (() => {
                                //     switch(step){
                                //         case 0:
                                //             return ()

                                //         case 1:
                                //             return (<PartnerInvitationStep1 user={user}  step={step} setStep={setStep} timestamp={timestamp} nonce={nonce} signature={signature} />)

                                //         case 2:
                                //             return (<PartnerInvitationStep2 user={user} step={step} setStep={setStep} timestamp={timestamp} nonce={nonce} signature={signature} />)

                                //         case 3:
                                //             return (<PartnerInvitationStep3 />)
                                //     }
                                // })()
                            }
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
};